import { render, staticRenderFns } from "./EditGrinder.vue?vue&type=template&id=4a5e1543&scoped=true"
import script from "./EditGrinder.vue?vue&type=script&lang=js"
export * from "./EditGrinder.vue?vue&type=script&lang=js"
import style0 from "./EditGrinder.vue?vue&type=style&index=0&id=4a5e1543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e1543",
  null
  
)

export default component.exports